"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobProductPendingOrder = void 0;
const typeorm_1 = require("typeorm/browser");
const job_1 = require("./job");
let JobProductPendingOrder = class JobProductPendingOrder {
};
__decorate([
    (0, typeorm_1.ManyToOne)(() => job_1.Job),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", job_1.Job)
], JobProductPendingOrder.prototype, "job", void 0);
__decorate([
    (0, typeorm_1.Column)('text'),
    __metadata("design:type", String)
], JobProductPendingOrder.prototype, "productId", void 0);
__decorate([
    (0, typeorm_1.Column)('text'),
    __metadata("design:type", String)
], JobProductPendingOrder.prototype, "productName", void 0);
__decorate([
    (0, typeorm_1.Column)('text'),
    __metadata("design:type", String)
], JobProductPendingOrder.prototype, "supplierId", void 0);
__decorate([
    (0, typeorm_1.Column)('text'),
    __metadata("design:type", String)
], JobProductPendingOrder.prototype, "supplierName", void 0);
__decorate([
    (0, typeorm_1.Column)('int', {
        nullable: true,
        name: 'quantity',
    }),
    __metadata("design:type", Number)
], JobProductPendingOrder.prototype, "quantity", void 0);
JobProductPendingOrder = __decorate([
    (0, typeorm_1.ViewEntity)({
        expression: `
    SELECT -- version 6
      job_id,
      product_id,
      product_name,
      supplier_name,
      supplier_id,
      (job_quantity - COALESCE(ordered_quantity,0)) quantity
    FROM
      (SELECT
        j.sfid job_id,
        jp.product_id,
        p."name" product_name,
        jp.supplier_sfid supplier_id,
        a."name" supplier_name,
        jp.quantity job_quantity,
        (SELECT
          SUM(poi.quantity)
        FROM
          "public".product_order po
        JOIN
          "public".product_order_item poi ON poi.product_order_id = po.id
        WHERE
          po.job_id = j.sfid
          AND poi.product_id = jp.product_id
        ) ordered_quantity
      FROM
        public.job__c j
      JOIN
        opportunity_options oo ON oo.opportunity_sfid = j.opportunity__c
      JOIN
        job_product jp ON jp.job_api_id = j.api_id__c
      JOIN
        products p ON p.id = jp.product_id
      LEFT JOIN
        public.account a ON a.id = jp.supplier_sfid
      WHERE
        j.status__c IN ('open', 'accepted','appointment confirmed','started', 'on hold')
        AND supplier = 'gid'
        AND CASE
          WHEN oo.product_order_condition = 'Require Invoice EID'
            THEN j.invoicing_eid__c IS NOT NULL
          WHEN oo.product_order_condition = 'Require EID'
            THEN j.eid__c IS NOT NULL
          ELSE TRUE
        END
      ) jpp
    WHERE
      (job_quantity - COALESCE(ordered_quantity,0)) > 0
  `,
        name: 'job_product_pending_order',
        schema: 'public',
    })
], JobProductPendingOrder);
exports.JobProductPendingOrder = JobProductPendingOrder;
//# sourceMappingURL=job-product-pending-order.js.map